export * from "./sign-up.component";
